import React, { useState } from 'react';
import PhoneInput, { parsePhoneNumber, isValidPhoneNumber } from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import styles from './InventoryRetargModal.module.css';
import { MdNotificationsActive } from "react-icons/md";
import { notifyIfNoInventory } from '../../../Services/mainPageService';
import { useSelector } from 'react-redux';
import confirmationImg from '../../../assets/images/notify_retarg_confirm.png';

const InventoryRetargModal = ({ onClose, dateRange, adults = 2, child = 0 }) => {
  const { hotelData } = useSelector((state) => state.hotelInfo);
  const { id } = hotelData;
  const [formData, setFormData] = useState({
    name: '',
    email: '',
  });
  const [phoneNumber, setPhoneNumber] = useState('');
  const [errors, setErrors] = useState({
    name: '',
    email: '',
    mobile: ''
  });
  const [isSubmitted, setIsSubmitted] = useState(false);

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
    
    // Clear error when user types in the field
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const handlePhoneChange = (value) => {
    setPhoneNumber(value);
    
    // Clear mobile error when user changes phone number
    if (errors.mobile) {
      setErrors(prev => ({
        ...prev,
        mobile: ''
      }));
    }
  };

  const validateForm = () => {
    let valid = true;
    const newErrors = {
      name: '',
      email: '',
      mobile: ''
    };

    // Name validation
    if (!formData.name.trim()) {
      newErrors.name = 'Name is required';
      valid = false;
    }

    // Email validation
    if (!formData.email.trim()) {
      newErrors.email = 'Email is required';
      valid = false;
    } else if (!validateEmail(formData.email)) {
      newErrors.email = 'Please enter a valid email address';
      valid = false;
    }

    // Phone validation
    if (!phoneNumber) {
      newErrors.mobile = 'Phone number is required';
      valid = false;
    } else if (!isValidPhoneNumber(phoneNumber)) {
      newErrors.mobile = 'Please enter a valid phone number';
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    };

    const parsedPhone = parsePhoneNumber(String(phoneNumber||''));
    const obj = {
      dialCode: "+" + parsedPhone.countryCallingCode,
      mobile: parsedPhone.nationalNumber,
      ...formData,
      hotelId: id,
      checkInDate: dateRange?.startDate,
      checkOutDate: dateRange?.endDate,
      totalAdult: adults,
      totalChild: child,
    }
    await notifyIfNoInventory(obj);
    setIsSubmitted(true);
    setTimeout(() => {
      onClose();
    }, 3000);
  };

  const ConfirmationMessage = () => {
    return (
      <>
        <div className={styles.confirmation_container}>
          <div className={styles.iconContainer}>
          <img src={confirmationImg} alt="successfull" />
          </div>
          <h2 className={styles.confirmation_title}>You're on the List!</h2>
          <p className={styles.confirmation_message}>
            We'll let you know the moment a room becomes available. Stay tuned!
          </p>
        </div>
      </>
    );
  };

  return (
    <div className={styles.modalOverlay}>
      {
        isSubmitted ? (
          <div className={styles.modalContent}>
            <ConfirmationMessage />
          </div>
        )
        :
        (
          <div className={styles.modalContent}>
            <div className={styles.modalHeader}>
              <div className={styles.bellIcon}>
                <MdNotificationsActive size={24}/>
              </div>
              <button className={styles.closeButton} onClick={onClose}>
                <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
                  <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                </svg>
              </button>
            </div>
            
            <div className={styles.headerContentGrp}>
              <h2 className={styles.modalTitle}>Get Notified When Rooms Are Available</h2>
              <p className={styles.modalDescription}>
                Missed out on your preferred dates? <br></br>
                Enter your details, and we'll notify you as soon as a room opens up!
              </p>
            </div>
            
            <form onSubmit={handleSubmit}>
              <div className={styles.inputGroup}>
                <input
                  type="text"
                  name="name"
                  placeholder="Name"
                  value={formData.name}
                  onChange={handleChange}
                  className={`${styles.inputField} ${errors.name ? styles.inputError : ''}`}
                  required
                />
                {errors.name && <span className={styles.errorMessage}>{errors.name}</span>}
              </div>
              
              <div className={styles.inputGroup}>
                <input
                  type="email"
                  name="email"
                  placeholder="Email Address"
                  value={formData.email}
                  onChange={handleChange}
                  className={`${styles.inputField} ${errors.email ? styles.inputError : ''}`}
                  required
                />
                {errors.email && <span className={styles.errorMessage}>{errors.email}</span>}
              </div>
              
              <div className={styles.phoneInputGroup}>
                <PhoneInput
                  defaultCountry="IN"
                  value={phoneNumber}
                  onChange={handlePhoneChange}
                  className={`${styles.phoneInputWrapper} ${errors.mobile ? styles.phoneInputError : ''}`}
                  placeholder="Mobile Number"
                  required
                />
                {errors.mobile && <span className={styles.errorMessage}>{errors.mobile}</span>}
              </div>
              
              <div className={styles.submit_btn_box}>
                <button type="submit" className={styles.submitButton}>
                  Notify Me
                </button>
              </div>
            </form>
          </div>
        )
      }
    </div>
  );
};

export default InventoryRetargModal;